import { render } from "./PDetails2.vue?vue&type=template&id=00fdf343&scoped=true"
import script from "./PDetails2.vue?vue&type=script&lang=js"
export * from "./PDetails2.vue?vue&type=script&lang=js"

import "./PDetails2.vue?vue&type=style&index=0&id=00fdf343&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00fdf343"]])

export default __exports__